module.exports = "/build/web/svg/sponsor/molecaten.7079e8d5f4b53e02b00008cedc24e3f1.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/molecaten.svg
// module id = 219
// module chunks = 24